import store from '@/store'

function calcSoBonus (offer, stake, caller) {
  // PARLAYBOOST
  // PARLAYINSURANCE
  let soBonus = 0
  let s = stake // for PARLAYBOOST
  let amount = offer.Amount || 0
  //
  let useCalcPostPlacement = store.getters['sbBetslipState/useCalcPostPlacement']
  // console.log('calcSoBonus; useCalcPostPlacement:', useCalcPostPlacement)
  if (!useCalcPostPlacement && offer.isFinal) {
    return parseFloat(amount)
  }
  //
  let returnCapping = (offer.SOFilterValues && offer.SOFilterValues.ReturnCapping) || 0
  let unitStakeCapping = (offer.SOFilterValues && offer.SOFilterValues.UnitStakeCapping) || 0
  let minStake = (offer.SOFilterValues && offer.SOFilterValues.MinStake) || 0
  let maxStake = (offer.SOFilterValues && offer.SOFilterValues.MaxStake) || 0
  //
  if (minStake && s < minStake) {
    s = 0
  }
  if (maxStake && s > maxStake) {
    s = 0
  }
  s = unitStakeCapping ? Math.min(s, unitStakeCapping) : s

  if (offer.Id === 'PARLAYINSURANCE') {
    return s === 0 ? null : 0
  }

  soBonus = s * amount
  soBonus = returnCapping ? Math.min(soBonus, returnCapping) : soBonus

  // let prc = this.calcBonusPrc(amount)
  // let b = this.winning && prc && (this.winning * prc) / 100
  soBonus = soBonus || 0
  soBonus = soBonus && parseFloat(soBonus.toFixed(2))
  // console.log('calcSoBonus', offer, stake, '; soBonus:', soBonus, '; caller:', caller)
  return soBonus
}

function parseBetSlipExtraData (raw) {
  // console.log('parseBetSlipExtraData processData:', raw, 'typ:', typeof raw)
  let soJO = []
  for (let idfobet in raw) {
    try {
      let so = raw[idfobet]
      let soj = JSON.parse(so)
      soj.IdFOBet = idfobet
      soj = parseBetSlipExtraDataCore(soj)
      // console.log('soj-updated:', soj)
      soJO.push(soj)
    } catch (error) {
      console.log('processBetSlipExtraData error:', error)
      // throw error
    }
  }
  // console.log('processBetSlipExtraData called for iDFOBetSlip:', iDFOBetSlip, '; betsWithSO:', betsWithSO, '; SO:', soJO)
  return soJO
  // resolve(soJO && soJO.length ? soJO : null)
}

function parseBetSlipExtraDataCore (soj) {
  // console.log('parseBetSlipExtraDataCore:', soj)
  // let soj = data[idfobet]
  // soj.IdFOBet = idfobet
  //
  let boosts = ['PARLAYBOOST', 'VOUCHERPARLAYBOOST', 'VOUCHERWINNINGBOOST']
  let specialOffers = (soj && soj.SpecialOffers && soj.SpecialOffers['0']) || []
  for (let ofr of specialOffers) {
    if (boosts.includes(ofr.Id) || ofr.Id.includes('BOOST')) {
      ofr.id = ofr.id || ofr.Id
      ofr.Id = 'PARLAYBOOST'
    }
    if (ofr.Id.includes('INSURANCE')) {
      ofr.id = ofr.id || ofr.Id
      ofr.Id = 'PARLAYINSURANCE'
    }
  }
  let soVoucher = soj && soj.Vouchers && soj.Vouchers[0] && soj.Vouchers[0].Offers && soj.Vouchers[0].Offers[0]
  soj.Offers = soj.Offers || soj.offers || soj.SpecialOffers
  delete soj.offers
  delete soj.SpecialOffers
  soj.Offers = soj.Offers || {}
  soj.Offers['0'] = soj.Offers['0'] || []
  // console.log('soj-original:', soj)
  for (let offer in soj.Offers) {
    if (offer === '0' && soVoucher) {
      if (boosts.includes(soVoucher.Id) || soVoucher.Id.includes('BOOST')) {
        soVoucher.id = soVoucher.id || soVoucher.Id
        soVoucher.Id = 'PARLAYBOOST'
      }
      if (soVoucher.Id.includes('PARLAYINSURANCE')) {
        soVoucher.id = soVoucher.id || soVoucher.Id
        soVoucher.Id = 'PARLAYINSURANCE'
      }
      soj.Offers[offer].push(soVoucher)
    }
    for (let item of soj.Offers[offer]) {
      for (let key in item) {
        let key2 = key.charAt(0).toUpperCase() + key.slice(1)
        // let key2 = key.charAt(0).toLowerCase() + key.slice(1)
        if (key.toLowerCase() === 'sofiltervalues') {
          key2 = 'SOFilterValues'
        }
        if (key !== key2 && !['id', 'Id'].includes(key)) {
          item[key2] = item[key]
          delete item[key]
        }
        //
        if (key2 === 'SOFilterValues') {
          for (let key3 in item[key2]) {
            let key4 = key3.charAt(0).toUpperCase() + key3.slice(1)
            if (key3 !== key4) {
              item[key2][key4] = item[key2][key3]
              delete item[key2][key3]
            }
          }
        }
      }
      item.isFinal = true
    }
  }
  // console.log('soj-updated:', soj)
  return soj
}

export default {
  calcSoBonus,
  parseBetSlipExtraData,
  parseBetSlipExtraDataCore
}



// WEBPACK FOOTER //
// ./src/library/specialOffers/index.js